(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["project-media-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('project-media-grid')) {
    class ProjectMediaGrid extends HTMLElement {
      connectedCallback() {
        const items = this.querySelector('[data-project-items]');
        const cards = Array.from(
          this.querySelectorAll('[data-project-card]')
        );
        const filters = this.querySelector(
          '[data-project-filters]'
        );
        const emptyMessage = this.querySelector(
          '[data-project-empty]'
        );

        if (!items || cards.length === 0) return;

        cards
          .sort(
            (firstCard, secondCard) =>
              Number(firstCard.dataset.order) -
              Number(secondCard.dataset.order)
          )
          .forEach((card) => items.appendChild(card));

        if (!filters) return;

        const applications = new Map();

        cards.forEach((card) => {
          const values = (
            card.dataset.applications || ''
          )
            .split('|')
            .filter(Boolean);

          const labels = (
            card.dataset.applicationLabels || ''
          ).split('|');

          values.forEach((value, index) => {
            const label = labels[index] || value;

            if (!applications.has(value)) {
              applications.set(value, label);
            }
          });
        });

        Array.from(applications.entries())
          .sort((firstApplication, secondApplication) =>
            firstApplication[1].localeCompare(
              secondApplication[1]
            )
          )
          .forEach(([value, label]) => {
            const button =
              document.createElement('button');

            button.className =
              'fp-project-media-grid__filter';
            button.type = 'button';
            button.dataset.projectFilter = value;
            button.setAttribute(
              'aria-pressed',
              'false'
            );
            button.textContent = label;

            filters.appendChild(button);
          });

        if (applications.size < 2) {
          filters.hidden = true;
          return;
        }

        filters.addEventListener('click', (event) => {
          const selectedButton = event.target.closest(
            '[data-project-filter]'
          );

          if (!selectedButton) return;

          const selectedApplication =
            selectedButton.dataset.projectFilter;

          const filterButtons =
            filters.querySelectorAll(
              '[data-project-filter]'
            );

          let visibleCards = 0;

          filterButtons.forEach((button) => {
            const isSelected =
              button === selectedButton;

            button.classList.toggle(
              'is-active',
              isSelected
            );

            button.setAttribute(
              'aria-pressed',
              String(isSelected)
            );
          });

          cards.forEach((card) => {
            const cardApplications = (
              card.dataset.applications || ''
            )
              .split('|')
              .filter(Boolean);

            const shouldShow =
              selectedApplication === 'all' ||
              cardApplications.includes(
                selectedApplication
              );

            card.hidden = !shouldShow;

            if (shouldShow) {
              visibleCards += 1;
            }
          });

          if (emptyMessage) {
            emptyMessage.hidden =
              visibleCards !== 0;
          }
        });
      }
    }

    customElements.define(
      'project-media-grid',
      ProjectMediaGrid
    );
  }

  } catch(e) { console.error(e); }
})();
})();
